import { useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"

import UserActions from "../../../../Containers/User/reducer"

export const useUploadTransactions = ({ businessId, notification }) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { adyenFilesUploading } = useSelector((state) => state.user)

  useEffect(() => {
    dispatch(UserActions.userSetProp("adyenFilesUploading", false))
  }, [])

  const uploadFilesRequest = (data) => {
    dispatch(
      UserActions.adyenUploadFilesRequest({
        ...data,
        onSuccess: () => {
          notification.success({
            message: "Adyen data is uploaded successfully"
          })
          if (businessId)
            dispatch(
              UserActions.getPaymentProcessorsRequest({
                integrationsPage: true,
                merchant_id: businessId,
                return_url: process.env.REACT_APP_BASE_URI + pathname
              })
            )
        },
        onError: (e) => {
          let message = "Failed to upload Adyen data"
          if (typeof e?.message?.detail === "string") message = e.message.detail
          notification.error({
            message: message
          })
        }
      })
    )
  }

  const handleUploadFiles = (integration) => {
    const input = document.createElement("input")
    input.type = "file"
    input.accept = ".csv"
    input.multiple = true
    input.onchange = (e) => {
      const files = e.target.files
      if (files && files.length > 0) {
        const filesArray = Array.from(files)
        uploadFilesRequest({ files: filesArray, merchant_id: businessId })
      }
    }
    input.click()
  }

  return { handleUploadFiles, adyenFilesUploading }
}
